import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import useCylindoDimensionShots from 'data-hooks/useCylindoDimensionShots';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import PDPInfoTable from '../PDPInfoTable';
import PDPDimensionsImage from '../PDPDimensionsContent/PDPDimensionsImage';
import PDPInfoSectionLayout from './PDPInfoSectionLayout';

// Dimensions tab: the rail's measurement table on the left, its image on the right
const PDPInfoDimensionsSection = () => {
  const $ = _c(26);
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    loading,
    error,
    data: t0
  } = useProductAttributes();
  const {
    dimensions,
    boxDimensions
  } = t0;
  const {
    hasCylindoDimensionShots,
    dimensionShotUrls,
    currentDimensionShot,
    selectedDimensionShotIndex,
    setSelectedDimensionShotIndex,
    dimensionalImageDesktop,
    dimensionalImageMobile
  } = useCylindoDimensionShots();
  if (error) {
    return null;
  }
  const name = basicDetails?.name ?? "";
  const hasImage = hasCylindoDimensionShots ? !!currentDimensionShot : !!(dimensionalImageDesktop || dimensionalImageMobile);
  let t1;
  if ($[0] !== currentDimensionShot || $[1] !== dimensionShotUrls || $[2] !== dimensionalImageDesktop || $[3] !== dimensionalImageMobile || $[4] !== hasCylindoDimensionShots || $[5] !== hasImage || $[6] !== loading || $[7] !== selectedDimensionShotIndex || $[8] !== setSelectedDimensionShotIndex) {
    t1 = !loading && hasImage && <PDPDimensionsImage dimensionsDesktopImage={dimensionalImageDesktop} dimensionsMobileImage={dimensionalImageMobile} isSidebarContent={true} hasCylindoDimensionShots={hasCylindoDimensionShots} dimensionShotUrls={dimensionShotUrls} currentDimensionShot={currentDimensionShot} selectedDimensionShotIndex={selectedDimensionShotIndex} setSelectedDimensionShotIndex={setSelectedDimensionShotIndex} />;
    $[0] = currentDimensionShot;
    $[1] = dimensionShotUrls;
    $[2] = dimensionalImageDesktop;
    $[3] = dimensionalImageMobile;
    $[4] = hasCylindoDimensionShots;
    $[5] = hasImage;
    $[6] = loading;
    $[7] = selectedDimensionShotIndex;
    $[8] = setSelectedDimensionShotIndex;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const image = t1;
  const t2 = `${name} Dimensions`;
  let t3;
  if ($[10] !== t2) {
    t3 = t2.trim();
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== dimensions || $[13] !== loading) {
    t4 = <PDPInfoTable items={dimensions} loading={loading} />;
    $[12] = dimensions;
    $[13] = loading;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== loading) {
    t5 = !loading && <Link className="inline-block mt-4 text-xs font-bold text-brand no-underline hover:cursor-pointer hover:underline" to="/fit-guide" target="_blank">Measure for delivery</Link>;
    $[15] = loading;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== boxDimensions || $[18] !== loading) {
    t6 = boxDimensions?.length > 0 && <div className="[border-top:1px_solid_#e5e5e5] mt-8 pt-8"><h4 className="text-base font-bold text-gray m-0">Shipping Dimensions</h4><PDPInfoTable items={boxDimensions} loading={loading} /></div>;
    $[17] = boxDimensions;
    $[18] = loading;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== image || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
    t7 = <PDPInfoSectionLayout heading={t3} aside={image}>{t4}{t5}{t6}</PDPInfoSectionLayout>;
    $[20] = image;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
};
export default PDPInfoDimensionsSection;